import React from "react";
import * as ReactDOMClient from "react-dom/client";
import { App } from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { UserContextProvider } from "./modules/user/contexts/user.context";
import { OfflineSiteContextProvider } from "./modules/offline/contexts/offline-site.context";
import "./i18n";
import "./theme/ionic";
import { AnnotationFormContextProvider } from "./modules/plan/contexts/annotation-form.context";

const rootElement = document.getElementById("root");
const root = ReactDOMClient.createRoot(rootElement!);

root.render(
  <React.StrictMode>
    <UserContextProvider>
      <OfflineSiteContextProvider>
        <AnnotationFormContextProvider>
          <App />
        </AnnotationFormContextProvider>
      </OfflineSiteContextProvider>
    </UserContextProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
